import { render, staticRenderFns } from "./BirthdayCare.vue?vue&type=template&id=42f3ff74&scoped=true"
import script from "./BirthdayCare.vue?vue&type=script&lang=js"
export * from "./BirthdayCare.vue?vue&type=script&lang=js"
import style0 from "./BirthdayCare.vue?vue&type=style&index=0&id=42f3ff74&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42f3ff74",
  null
  
)

export default component.exports